import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 18.75a6.96 6.96 0 0 1-6.07-3.5c-1.258-2.16-1.258-4.812 0-7A7.02 7.02 0 0 1 12 4.75c2.488 0 4.785 1.34 6.043 3.5 1.258 2.188 1.258 4.84 0 7A6.95 6.95 0 0 1 12 18.75m3.09-8.285h-.027c.273-.246.273-.656 0-.93a.644.644 0 0 0-.903 0l-3.035 3.063-1.285-1.286c-.274-.273-.684-.273-.93 0a.6.6 0 0 0 0 .903l1.75 1.75c.246.273.656.273.93 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }